/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';

export function faqs() {
  $('.faqs__toggle').hide();
  $('.faqs__question').on('click tap', function () {
    $(this).parent().toggleClass('active');
    $(this).toggleClass('active');
    $(this).parent().find('.faqs__toggle').slideToggle();
  });
}

export function readmore() {
  $('.readmore__toggle').hide();
  $('.readmore__question').on('click tap', function () {
    $(this).parent().toggleClass('active');
    $(this).toggleClass('active');
    $(this).parent().find('.readmore__toggle').slideToggle();
    if($(this).hasClass('active')) {
      $(this).parent().find('.readmore__question')[0].innerHTML = "Read Less"
    } else {
      $(this).parent().find('.readmore__question')[0].innerHTML = "Read More"
    }
  });
}
